import React, { useState, useEffect } from "react";
import ModalComponent from "../../../ModalComponent";
import * as HTTPServices from "../../../../api/HTTPServices";

const Index = ({
  handleOpenMedicalRecords,
  handleCloseMedicalRecords,
  audienceId,
  visitToken,
  SeenAttach,
}) => {
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const fetchFIle = () => {
      const RequestService = HTTPServices.getMethod(
        "doctor_exp",
        "audience=" + audienceId + "&visit=" + visitToken,
        "true"
      );

      RequestService.then(function (response) {
        if (response) {
          setFiles(response);

          SeenAttach(audienceId, visitToken);
        }
      }).catch(function (error) {});
    };
    fetchFIle();
  }, [SeenAttach, audienceId, visitToken]);

  return (
    <ModalComponent
      open={handleOpenMedicalRecords}
      handleClose={handleCloseMedicalRecords}
      closeBtn={true}
      confirmBtn={false}
      handleOk={null}
      title="Patient history and medical status summary (visible to physician only)"
    >
      <div style={{ margin: 10, paddingRight: 15 }}>
        <p>
          Dear doctor <br />
          This section is for summarizing the visit, patient history and
          documents that are only visible to you
          <br />
          It is possible to place text or files alone or together
        </p>
        <p>patient name:</p>
        <p>Patient age:</p>
      </div>
      <div>
        {files && files.length > 0 ? (
          // <ExplanationItemFile
          //   AddDeleteAttach={this.AddDeleteAttach}
          //   Files={files}
          //   UserId={UserLogin.client_id}
          // />
          "asd"
        ) : (
          <div>
            <div>
              <div>
                <div>
                  <figure>
                    {/* <img src={DossierIcon} alt="nothing found" /> */}
                    <figcaption>
                      <p>There are no medical instructions to view</p>
                      <p>
                        If you wish, click the + button and send a new doctor's
                        prescription to the patient.
                      </p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </ModalComponent>
  );
};

export default Index;
